// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Primary Color */

/* Accent Color */

/* Neutral color */

/* Feedback color */

/* Typography */

/* Border */

/* Forms */

/* Button */
`, "",{"version":3,"sources":["webpack://./src/components/library/style/colors.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAMlB,iBAAiB;;AAOjB,kBAAkB;;AAMlB,mBAAmB;;AAWnB,eAAe;;AAMf,WAAW;;AAGX,UAAU;;AAMV,WAAW","sourcesContent":["/* Primary Color */\r\n@value color-red: #DE330D;\r\n@value color-red-light: #F24C27;\r\n@value color-red-dark: #A32003;\r\n@value color-red-bg: #F8D7DA;\r\n\r\n/* Accent Color */\r\n@value color-purple: #4F67F3;\r\n@value color-purple-light: #7D8FF5;\r\n@value color-purple-dark: #404FA1;\r\n@value color-purple-bg: #EBEEFF;\r\n@value color-purple-gray: #F8F9FB;\r\n\r\n/* Neutral color */\r\n@value color-gray: #CCCCCC;\r\n@value color-gray-light: #EFEFEF;\r\n@value color-gray-dark: #72757E;\r\n@value color-black: #2C333E;\r\n\r\n/* Feedback color */\r\n@value color-success: #0EDC97;\r\n@value color-success-light: #D1ECF1;\r\n@value color-success-dark: #155724;\r\n@value color-warning: #FBC506;\r\n@value color-warning-light: #FFF3CD;\r\n@value color-warning-dark: #FBC506;\r\n@value color-error: #F24C27;\r\n@value color-error-light: #F8D7DA;\r\n@value color-error-dark: #DE330D;\r\n\r\n/* Typography */\r\n@value color-text: color-black;\r\n@value color-text-subtle: color-gray-dark;\r\n@value color-link: color-purple;\r\n@value color-link-visited: color-purple-dark;\r\n\r\n/* Border */\r\n@value color-border: color-gray;\r\n\r\n/* Forms */\r\n@value color-form-border: color-gray;\r\n@value color-form-focus: color-purple;\r\n@value color-form-error: color-error;\r\n@value color-form-success: color-success;\r\n\r\n/* Button */\r\n@value color-button-primary: color-red;\r\n@value color-button-primary-hover: color-red-dark;\r\n@value color-button-primary-focus: color-red-light;\r\n@value color-button-secondary: color-purple;\r\n@value color-button-secondary-hover: color-purple-dark;\r\n@value color-button-secondary-focus: color-purple-light;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-red": `#DE330D`,
	"color-red-light": `#F24C27`,
	"color-red-dark": `#A32003`,
	"color-red-bg": `#F8D7DA`,
	"color-purple": `#4F67F3`,
	"color-purple-light": `#7D8FF5`,
	"color-purple-dark": `#404FA1`,
	"color-purple-bg": `#EBEEFF`,
	"color-purple-gray": `#F8F9FB`,
	"color-gray": `#CCCCCC`,
	"color-gray-light": `#EFEFEF`,
	"color-gray-dark": `#72757E`,
	"color-black": `#2C333E`,
	"color-success": `#0EDC97`,
	"color-success-light": `#D1ECF1`,
	"color-success-dark": `#155724`,
	"color-warning": `#FBC506`,
	"color-warning-light": `#FFF3CD`,
	"color-warning-dark": `#FBC506`,
	"color-error": `#F24C27`,
	"color-error-light": `#F8D7DA`,
	"color-error-dark": `#DE330D`,
	"color-text": `#2C333E`,
	"color-text-subtle": `#72757E`,
	"color-link": `#4F67F3`,
	"color-link-visited": `#404FA1`,
	"color-border": `#CCCCCC`,
	"color-form-border": `#CCCCCC`,
	"color-form-focus": `#4F67F3`,
	"color-form-error": `#F24C27`,
	"color-form-success": `#0EDC97`,
	"color-button-primary": `#DE330D`,
	"color-button-primary-hover": `#A32003`,
	"color-button-primary-focus": `#F24C27`,
	"color-button-secondary": `#4F67F3`,
	"color-button-secondary-hover": `#404FA1`,
	"color-button-secondary-focus": `#7D8FF5`
};
export default ___CSS_LOADER_EXPORT___;
